import React from 'react';
import { connect } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import './video.styl';
//widget
import WidgetComponent from '../widget/WidgetComponent'
//video file
import video_aq_mid from '../../media/video1_cut.mp4';
import video_aq_bad from '../../media/video2_cut.mp4';
import video_aq_good from '../../media/video3_cut.mp4';

class Video extends React.Component {
  constructor(props){
    super(props);

    this.videos = [video_aq_mid, video_aq_bad, video_aq_good];
    this.state = {'video': 0, 'aqi': 56};
    this.scrollToDemo = this.scrollToDemo.bind(this);
  }

  scrollToDemo(e) {
    const targetEl = document.getElementById(e.currentTarget.dataset.targetId);
    window.scroll(0, targetEl.offsetTop - 40);
  }

  componentDidMount(){

    const videoPlayer = document.getElementById('video-player');
    videoPlayer.addEventListener('ended', ()=>{
      if(this.state.video === 0){
        this.setState({'video': 1, 'aqi': 22});
      }
      else if(this.state.video === 1){
        this.setState({'video': 2, 'aqi': 89});
      }
      else if(this.state.video === 2){
        this.setState({'video': 0, 'aqi': 56});
      }

      videoPlayer.load();
      videoPlayer.play();
    }, false);
  }

  render(){
    return (
      <div className="video-frame">
        <div className="video-overlay"></div>
        <WidgetComponent aqi={this.state.aqi} widgetContainer={'widget-container'}>
        </WidgetComponent>
        <div className="video-frame__button-wrapper">
          <button type="button" className="video-frame__button button" onClick={ this.scrollToDemo } data-target-id="demo">
            { this.props.locale === 'en' ? 'Try it yourself' : 'Probeer het zelf' }
          </button>
        </div>
        <video id='video-player' autoPlay muted playsInline>
          <source src={this.videos[this.state.video]} type="video/mp4" />
          Your browser does not support video
        </video>
        <div className="video-frame__shadow"></div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

export default connect(mapStateToProps, null)(Video);



// WEBPACK FOOTER //
// ./src/components/video/Video.js